module.exports.getElementOnCoords = function (elements, x, y, zoom) {
  return _.find(elements, function (elem) {
    var bb = svgedit.utilities.getBBox(elem);

    return bb.x * zoom < x && x < (bb.x + bb.width) * zoom
      && bb.y * zoom < y && y < (bb.y + bb.height) * zoom;
  });
};

module.exports.OverOutHandler = function (S, ghostId) {
  var ghostElement, overElement;

  return {
    out: out,
    over: over,
    updateContentDimensions: updateContentDimensions,
    getGhostElement: function () { return ghostElement; }
  };

  function updateContentDimensions (element) {
    var vector = $(element).children('g')[0];
    var image = $(element).children('image')[0];
    var elementBb = image.getBBox();
    var vectorBb = vector.getBBox();

    var elementRatio = elementBb.width / elementBb.height;
    var vectorRatio = vectorBb.width / vectorBb.height;
    var s = vectorRatio > elementRatio
      ? elementBb.width / vectorBb.width
      : elementBb.height / vectorBb.height;

    transform(vector, s, s, elementBb.x, elementBb.y);
  }

  function over (elementOnPosition, thumb) {
    if (overElement != elementOnPosition || !ghostElement) {
      ghostElement && ghostElement.remove();
      overElement && setOpacity(overElement, 1);

      overElement = elementOnPosition;

      addGhostElement(elementOnPosition, thumb);
      setOpacity(elementOnPosition, 0);
    }
  }

  function out () {
    setOpacity(overElement, 1);
    ghostElement.remove();
    ghostElement = null;
    overElement = null;
  }

  function addGhostElement (element, thumb) {
    var zoom = S.canvas.getZoom();
    var bb = svgedit.utilities.getBBox(element);
    var svgContent = $('#svgcontent')[0];

    ghostElement = document.createElementNS(svgedit.NS.SVG, 'image');
    S.canvas.assignAttributes(ghostElement, {
      'id': ghostId,
      'x': (parseFloat(svgContent.getAttribute('x')) + bb.x) * zoom,
      'y': (parseFloat(svgContent.getAttribute('y')) + bb.y) * zoom,
      'width': bb.width * zoom,
      'height': bb.height * zoom,
      'xlink:href': thumb
    });

    var selector = $('#svgpanel')[0];
    selector.appendChild(ghostElement);
  }

  function setOpacity (elem, val) {
    svgedit.utilities.assignAttributes(elem, { opacity: val }, 100);
  }

  function transform (element, scaleX, scaleY, translateX, translateY) {
    var translate = S.svgroot.createSVGTransform();
    var scale = S.svgroot.createSVGTransform();
    var rtranslate = S.svgroot.createSVGTransform();
    var tlist = svgedit.transformlist.getTransformList(element);

    translate.setTranslate(0, 0);
    scale.setScale(scaleX, scaleY);
    rtranslate.setTranslate(0, 0);

    tlist.appendItem(translate);
    tlist.appendItem(scale);
    tlist.appendItem(rtranslate);

    S.canvas.recalculateDimensions(element, element.getBBox());

    translate = S.svgroot.createSVGTransform();

    translate.setTranslate(translateX, translateY);
    tlist.appendItem(translate);
    S.canvas.recalculateDimensions(element);
  }
};
